// extracted by mini-css-extract-plugin
export default {"wrapper":"UnauthorizedLayout_wrapper__PB8hv","wrapper-left":"UnauthorizedLayout_wrapper-left__wveZ5","wrapper-right":"UnauthorizedLayout_wrapper-right__IF44s"};